//外部扩展CSS所用
export default [
  {
    name:"获取VFormRender组件",
    type:"VFormRender",
    func:"getFormRef",
    value:"this.getFormRef();//获取VFormRender组件"
  },
]



// WEBPACK FOOTER //
// ./src/components/Admin/Flow/config/FlowFormCssExtend.js